/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { darken, mode, whiten } from '@chakra-ui/theme-tools';
import { ThemeOverride } from '@chakra-ui/react';

export const ButtonStyle = {
  baseStyle: {
    borderRadius: '3xl',
    fontSize: 16,
  },
  sizes: {
    lg: {
      px: 16,
      fontSize: 14,
    },
    md: {
      px: 8,
      fontSize: 14,
    },
  },
  variants: {
    primary: (props: ThemeOverride) => ({
      bg: 'primary',
      color: 'white',
      _hover: {
        bg: mode(darken('primary', 20), whiten('primary', 20))(props),
        boxShadow: 'md',
      },
    }),
    secondary: (props: ThemeOverride) => ({
      bg: 'secondary',
      color: 'white',
      _hover: {
        bg: mode(darken('secondary', 20), whiten('secondary', 20))(props),
        boxShadow: 'md',
      },
    }),
    secondaryOutline: () => ({
      bg: 'transparent',
      color: 'secondary',
      borderColor: 'secondary',
      borderWidth: 1,
      _hover: {
        bg: 'secondary',
        color: 'white',
      },
    }),
    white: {
      bg: 'white',
      color: 'black',
    },
  },
  defaultProps: {
    variant: 'primary',
  },
};
